import React, { useRef, useState } from "react"
import SignatureCanvas from 'react-signature-canvas'
import Modal from "react-bootstrap/Modal"
import Button from "react-bootstrap/Button"
import classesForms from "./customForms.module.css"
import useS3DirectUpload from '../../hooks/useS3DirectUpload'
import Tooltip from "react-bootstrap/Tooltip"
import Spinner from "react-bootstrap/Spinner"
import { useEffect } from "react/cjs/react.development"


function SignatureModal({
    editingMode,
    clientId,
    answerItem,
    debouncedUpdateDB,
    imgSrc,
    timeStamp
}) {

    const sigCanvas = useRef();
    const [savedImage, setSavedImage] = useState(false);
    const [tempImage, setTempImage] = useState("");
    const [savedDate, setSavedDate] = useState("");
    const [sigSaved, setSigSaved] = useState("");
    const [sigSaveLoading, setSaveSigLoading] = useState(false);
    const [formattedTimeStamp, setFormattedTimestamp] = useState("");

    function clearSigCanvas() {
        sigCanvas.current.clear();
    }

    function formatDate(dt) {
        let newDate = (dt.getMonth() + 1) + "/" + dt.getDate() + "/" + dt.getFullYear();
        return newDate;
    }

    async function prepareSigCanvas() {
        let imageURL = sigCanvas.current.getTrimmedCanvas().toDataURL("image/png");
        let blob = await fetch(imageURL)
            .then(res => (
                res.blob()
            ))
        const imageFile = new File([blob], "signature", { type: "image/png" })
        setTempImage(imageURL);
        setSavedImage(true);
        setSavedDate(formatDate(new Date()))

        clearSigCanvas();

        if (editingMode) return;
        setSignatureUpload(imageFile)

    }
    async function saveSigCanvas() {
        saveToS3();
        clearSigCanvas();
    }

    function removeSigCanvas() {
        setTempImage("");
        setSavedImage(false);
    }

    const {
        file: newSignature,
        processUpload: processSignatureUpload,
        setUpload: setSignatureUpload,
        clearUpload: clearSignatureUpload
    } = useS3DirectUpload()


    async function saveToS3() {
        if (Boolean(newSignature)) {
            setSaveSigLoading(true)
            const s3Res = await processSignatureUpload()
            setSaveSigLoading(false)

            if (s3Res.success) {
                let answer = s3Res.payload.url;
                let answer_field_id = answerItem.answer_field_id
                let client_id = clientId;
                let question_type = "signature"
                let answer_id = answerItem.answer_values?.answer_id
                let integer_answer = 0
                let payload = { client_id, question_type, answer, integer_answer, answer_field_id, answer_id }
                debouncedUpdateDB(payload)
                setSigSaved(true);
            }
            clearSignatureUpload();
        }
    }


    return (
        <div>
            {imgSrc ?
                <div>
                    <img src={imgSrc} style={{ maxWidth: "300px"}}/>
                    <div className="mt-2">
                        <i> {formattedTimeStamp}</i>
                    </div>
                </div>
                :
                <>
                    {!sigSaved &&
                        <div>
                            <SignatureCanvas
                                onEnd={prepareSigCanvas}
                                ref={sigCanvas}
                                canvasProps={{
                                    height: 200,
                                    className: classesForms.sigCanvas
                                }} />

                            <label className="btn btn-sm btn-primary shadow-sm mt-2">
                                Or Upload Signature Here
                                <input
                                    type="file"
                                    hidden
                                    onChange={(e) => {
                                        setSavedImage(true);
                                        setSignatureUpload(e.target.files[0])
                                        setSavedDate(formatDate(new Date()))
                                        setTempImage(URL.createObjectURL(e.target.files[0]));
                                    }}
                                    //Doing this to ensure that the onChange event fires even if the same file is selected
                                    onClick={(event) => {
                                        event.target.value = null;
                                    }}
                                />
                            </label>
                        </div>}

                    {savedImage &&
                        <div>
                            <div style={{ maxWidth: "300px", border: "2px solid grey", borderRadius: "10px" }} className="mt-3 p-3 d-flex align-items-center">
                                <div>
                                    <img style={{ maxWidth: "150px" }} src={tempImage} />
                                    <div className="mt-2">
                                        <i> {savedDate} </i>
                                    </div>
                                </div>

                                {!sigSaved &&
                                    <div >
                                        <Button className="ml-3 py-0 " variant={"danger"} onClick={() => removeSigCanvas()}>
                                            Remove
                                        </Button>
                                    </div>}
                            </div>

                            {!sigSaved &&
                                <div className="mt-2">
                                    <Button variant={"primary"} onClick={() => saveSigCanvas()}>
                                        {sigSaveLoading ?
                                            <Spinner size="sm" animation="border" role="status">
                                                <span className="sr-only">Loading...</span>
                                            </Spinner> : <span> Save Signature</span>}
                                    </Button>

                                    <span > <i className="fas fa-info-circle ml-2" />
                                        {editingMode ?
                                            <span> This action would be permanent for clients</span> :
                                            <span> This action is permament </span>}
                                    </span>
                                </div>}
                        </div>}
                </>}
        </div >
    )
}

export default SignatureModal;